module.exports = __webpack_public_path__ + "static/media/cams-ncp-cams.081dcc49.png";